module.exports = __webpack_public_path__ + "img/expertise_quote.6495f40f.png";